import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { ISortBy } from "../../../../types";
import usePagination from "../../../../hooks/usePagination";
import { ActiveFilter } from "../../../../components/ui/FilterSearch";
import { LogsHistoryTable } from "../../../../components/ui";
import { APIAgentActivityLog } from "../../../../api";
import { rithmicAccountsActions } from "../../../../reducers/rithmicAccounts";
import { AGENT_ACTIVITY_LOG_API_URLS } from "../../../../api/agentActivityLog";

const UsageHistory: React.FC = () => {
  const dispatch = useDispatch();
  const pagination = usePagination();
  const { loading, data } = useSelector(
    (state) => state.rithmicAccounts.rithmicAccountsCreatingHistory
  );
  const [activeFilters, setActiveFilters] = useState<Record<string, ActiveFilter>>({});
  const [sortBy, setSortBy] = useState<ISortBy>({ by: "log_time", order: false });

  const { error, isError } = useQuery({
    queryKey: [
      AGENT_ACTIVITY_LOG_API_URLS.getAgentActivityLog,
      sortBy.by,
      sortBy.order,
      pagination.page,
      pagination.limit,
      activeFilters,
    ],
    queryFn: async ({ signal }) => {
      dispatch(rithmicAccountsActions.fetchCreatingHistoryRequest());
      const response = await APIAgentActivityLog.getActivityLogsRequest(
        {
          limit: pagination.limit,
          page: pagination.page,
          sortBy,
          activeFilters: {
            ...activeFilters,
            field_name: {
              value: "create_rithmic_account",
              label: "Create Rithmic Account",
              key: "field_name",
            },
          },
        },
        signal
      );
      pagination.setCount(response.data.count);
      dispatch(rithmicAccountsActions.fetchCreatingHistorySuccess(response.data));
      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(rithmicAccountsActions.fetchCreatingHistoryFailed());
    }
  }, [error, isError]);

  return (
    <LogsHistoryTable
      logs={data.logs}
      loading={loading}
      count={data.count}
      pagination={pagination}
      handleSort={[sortBy, setSortBy]}
      tableColumns={["log_time", "agent", "new_value"]}
      setActiveFilters={setActiveFilters}
      filterOptions={[
        { key: "admin", label: "Agent" },
        { key: "log_time", label: "Date", type: "date" },
      ]}
      defaultSearchFilters={["admin"]}
    />
  );
};

export default UsageHistory;
